export default {"src":"/_next/static/media/piatti.b23a285e.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};